import React from 'react';
// import { Link, useLocation } from 'react-router-dom'; // Remove this line

const Footer = () => {
  // const location = useLocation(); // Remove this line
  const currentYear = new Date().getFullYear();
  
  // Handle navigation link clicks - scroll to top if already on that page
  // const handleNavLinkClick = (path) => { // Remove this function
  //   if (location.pathname === path) {
  //     window.scrollTo({
  //       top: 0,
  //       behavior: 'smooth'
  //     });
  //   }
  // };

  return (
    <footer className="bg-gradient-to-r from-stone-700 to-stone-800 text-white shadow-md">
      <div className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* About Section */}
          <div>
            <h3 className="text-lg font-semibold text-slate-300 mb-4">About TravelRadar</h3>
            <p className="text-stone-300 leading-relaxed">
              TravelRadar brings you the best travel experiences from around the world.
              From hidden destinations to cultural adventures, we help you discover extraordinary places and create unforgettable memories.
            </p>
          </div>

          {/* Site Info Section */}
          <div>
            <h3 className="text-lg font-semibold text-slate-300 mb-4">Site Info</h3>
            <div className="flex flex-col space-y-2">
              {/* <Link 
                to="/about-us"
                className="inline-block text-gray-300 hover:text-[#FF8A00] transition-all duration-300 px-3 py-1.5 rounded-md hover:bg-[#4E342E]"
                onClick={() => handleNavLinkClick('/about-us')}
              > */}
              <a 
                href="/about.html"
                className="inline-block text-stone-300 hover:text-white transition-all duration-300 px-3 py-1.5 rounded-md hover:bg-slate-600"
              > {/* Changed Link to a, removed onClick */}
                About Us
              {/* </Link> */}
              </a>
              {/* <Link 
                to="/terms-of-service"
                className="inline-block text-gray-300 hover:text-[#FF8A00] transition-all duration-300 px-3 py-1.5 rounded-md hover:bg-[#4E342E]"
                onClick={() => handleNavLinkClick('/terms-of-service')}
              > */}
              <a 
                href="/terms.html" 
                className="inline-block text-stone-300 hover:text-white transition-all duration-300 px-3 py-1.5 rounded-md hover:bg-slate-600"
              > {/* Changed Link to a, removed onClick */}
                Terms of Service
              {/* </Link> */}
              </a>
              {/* <Link 
                to="/privacy-policy"
                className="inline-block text-gray-300 hover:text-[#FF8A00] transition-all duration-300 px-3 py-1.5 rounded-md hover:bg-[#4E342E]"
                onClick={() => handleNavLinkClick('/privacy-policy')}
              > */}
              <a 
                href="/privacy.html"
                className="inline-block text-stone-300 hover:text-white transition-all duration-300 px-3 py-1.5 rounded-md hover:bg-slate-600"
              > {/* Changed Link to a, removed onClick */}
                Privacy Policy
              {/* </Link> */}
              </a>
            </div>
          </div>

          {/* Travel Categories Section */}
          <div>
            <h3 className="text-lg font-semibold text-slate-300 mb-4">Travel Categories</h3>
            <div className="flex flex-col space-y-2">
              <a 
                href="/category.html?category=hidden-destinations"
                className="inline-block text-stone-300 hover:text-white transition-all duration-300 px-3 py-1.5 rounded-md hover:bg-slate-600"
              >
                Hidden Destinations
              </a>
              <a 
                href="/category.html?category=adventure-escapes"
                className="inline-block text-stone-300 hover:text-white transition-all duration-300 px-3 py-1.5 rounded-md hover:bg-slate-600"
              >
                Adventure Escapes
              </a>
              <a 
                href="/category.html?category=cultural-experiences"
                className="inline-block text-stone-300 hover:text-white transition-all duration-300 px-3 py-1.5 rounded-md hover:bg-slate-600"
              >
                Cultural Experiences
              </a>
              <a 
                href="/category.html?category=travel-tips"
                className="inline-block text-stone-300 hover:text-white transition-all duration-300 px-3 py-1.5 rounded-md hover:bg-slate-600"
              >
                Travel Tips
              </a>
            </div>
          </div>
        </div>
      </div>
      
      {/* Bottom Bar */}
      <div className="bg-stone-800 py-4">
        <div className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row justify-between items-center">
          <p className="text-stone-400 text-sm">
            &copy; {currentYear} TravelRadar. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 